import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/rv/screen.png'
import _imports_1 from '@/assets/images/rv/arrow-down.svg'
import _imports_2 from '@/assets/images/copy-icon.svg'
import _imports_3 from '@/assets/images/date-icon.svg'
import _imports_4 from '@/assets/images/rv/arrow-blue.png'


const _withScopeId = n => (_pushScopeId("data-v-e1295f54"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "condition-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "screen"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "筛选条件", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出查询结果")
const _hoisted_6 = { style: {"padding-left":"16px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车架号", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车型", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商中文名称", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "零售日期", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1))
const _hoisted_13 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_15 = { style: {"margin-top":"8px"} }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "零售类型", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "激励适用性", -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode("更多 ")
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"transform":"rotate(180deg)","margin-left":"4px"}
}, null, -1))
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "生产编号", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "车型分类", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "年款", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "批发来源", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "特殊车辆用途", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "动力类型", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "品牌", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商代码 (cofico)", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商代码( SWT )", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "经销商英文名称", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "区域", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "发票日期", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "上牌日期", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 收起 ")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"margin-left":"4px"}
}, null, -1))
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "提交状态", -1))
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" 收起")
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  style: {"margin-left":"4px"}
}, null, -1))
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "table-box" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("查看")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("发票")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("行驶证")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("详细")
const _hoisted_48 = { class: "pagination-container d-f justify-e" }
const _hoisted_49 = { class: "batch-query-title" }
const _hoisted_50 = { style: {"padding":"0 8px"} }
const _hoisted_51 = { class: "list-title" }
const _hoisted_52 = { class: "list-content" }
const _hoisted_53 = /*#__PURE__*/_createTextVNode("清除")
const _hoisted_54 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_auto_complete = _resolveComponent("a-auto-complete")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_Preview = _resolveComponent("Preview")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_fail_reason = _resolveComponent("fail-reason")!
  const _component_retail_validation_detail = _resolveComponent("retail-validation-detail")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumb, { dataSource: [] }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["condition", { 'open-condition': _ctx.isOpen }])
      }, [
        _createElementVNode("section", _hoisted_2, [
          _createElementVNode("div", null, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("img", {
              src: _imports_1,
              class: _normalizeClass(["arrow", { 'rotate-arrow': _ctx.isOpen }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => {
              _ctx.isOpen = !_ctx.isOpen;
              _ctx.isOpenPanle = false;
              _ctx.activeKey = '';
            })
            }, null, 2)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_a_button, {
              class: "button",
              onClick: _ctx.exportResult
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _createElementVNode("section", {
          class: _normalizeClass(["condition-content clearfix", { 'open-condition-content': _ctx.isOpen }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_a_space, { style: {"display":"flex","justify-content":"space-between"} }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_7,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: _ctx.vinNo,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.vinNo) = $event)),
                            placeholder: "请输入",
                            maxlength: 17,
                            style: {"width":"200px"}
                          }, null, 8, ["value"]),
                          _createElementVNode("img", {
                            src: _imports_2,
                            style: {"margin":"0 8px 0 -4px","cursor":"pointer"},
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.batchQueryEvent('vinNo')))
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8,
                      _createVNode(_component_a_input, {
                        value: _ctx.model,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model) = $event)),
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_9,
                      _createVNode(_component_a_auto_complete, {
                        value: _ctx.dealerNameCn,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dealerNameCn) = $event)),
                        options: _ctx.dealerNameCnArray,
                        onSearch: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleSearch($event, 'C'))),
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-right":"8px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.retailStartDate, _ctx.retailEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.dateChangeEvent($event, 'retail'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_11
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_12,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            style: {"margin-right":"8px"},
                            onClick: _ctx.mulSearchEvent
                          }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_a_button, {
                            class: "button",
                            onClick: _ctx.resetEvent
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_a_space, {
                direction: "vertical",
                style: {"margin-right":"8px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_16,
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.usage,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.usage) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usageArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item,
                              key: item
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_space, { direction: "vertical" }, {
                default: _withCtx(() => [
                  _hoisted_17,
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: _ctx.checkStatus,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkStatus) = $event)),
                        placeholder: "请选择",
                        allowClear: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rebateFlagArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item.code,
                              key: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.msg), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"]),
                      _withDirectives(_createElementVNode("span", {
                        class: "more",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => {
                    _ctx.isOpenPanle = true;
                    _ctx.showCollapsed = false;
                  })
                      }, _hoisted_20, 512), [
                        [_vShow, !_ctx.isOpenPanle]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        _createElementVNode("section", {
          class: _normalizeClass(["condition-content-panle clearfix", { 'open-content-condition-panle': _ctx.isOpenPanle }])
        }, [
          _createVNode(_component_a_collapse, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.activeKey) = $event)),
            style: {"padding-left":"16px","margin-top":"8px"},
            onChange: _ctx.handleActiveKey
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_collapse_panel, {
                key: "1",
                header: "车辆类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_21,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                placeholder: "请输入",
                                value: _ctx.commissionNo,
                                "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.commissionNo) = $event))
                              }, null, 8, ["value"]),
                              _createElementVNode("img", {
                                src: _imports_2,
                                style: {"margin":"0 8px 0 -4px","cursor":"pointer"},
                                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.batchQueryEvent('commissionNo')))
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_22,
                          _createVNode(_component_a_select, {
                            value: _ctx.typeClass,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.typeClass) = $event)),
                            placeholder: "请选择",
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.typeClassArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.code,
                                  value: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_23,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.modelYear,
                            "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.modelYear) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelYearArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.code,
                                  value: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_24,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.entity,
                            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.entity) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_25,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.specialUsage,
                            "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.specialUsage) = $event)),
                            allowClear: "",
                            style: {"width":"170px"}
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.specialUsageArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.powerTrain,
                            "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.powerTrain) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.powerTrainArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  key: item.code,
                                  value: item.code
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_27,
                          _createVNode(_component_a_space, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                value: _ctx.brand,
                                "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.brand) = $event)),
                                allowClear: ""
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.brandArray, (item) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, {
                                      value: item,
                                      key: item
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "2",
                header: "经销商类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_28,
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerCofficoCode,
                            "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.dealerCofficoCode) = $event)),
                            options: _ctx.coficoArray,
                            onSearch: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSearch($event, 'D'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_29,
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerSwtCode,
                            "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.dealerSwtCode) = $event)),
                            options: _ctx.swtArray,
                            onSearch: _cache[21] || (_cache[21] = ($event: any) => (_ctx.handleSearch($event, 'S'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _createVNode(_component_a_auto_complete, {
                            value: _ctx.dealerNameEn,
                            "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.dealerNameEn) = $event)),
                            options: _ctx.dealerNameEnArray,
                            onSearch: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleSearch($event, 'E'))),
                            allowClear: ""
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_space, { direction: "vertical" }, {
                        default: _withCtx(() => [
                          _hoisted_31,
                          _createVNode(_component_a_select, {
                            placeholder: "请选择",
                            value: _ctx.region,
                            "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.region) = $event)),
                            allowClear: ""
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.areasArray, (item) => {
                                return (_openBlock(), _createBlock(_component_a_select_option, {
                                  value: item,
                                  key: item
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.msg), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "3",
                header: "日期类别"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_space, { direction: "vertical" }, {
                    default: _withCtx(() => [
                      _hoisted_32,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.invoiceStartDate, _ctx.invoiceEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.dateChangeEvent($event, 'invoice'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_33
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-left":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34,
                      _createVNode(_component_a_space, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_range_picker, {
                            style: {"width":"250px","margin-right":"8px"},
                            value: [_ctx.licenseStartDate, _ctx.licenseEndDate],
                            placeholder: ['开始时间', '结束时间'],
                            valueFormat: "YYYY/MM/DD",
                            onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.dateChangeEvent($event, 'license'))),
                            format: "YYYY/MM/DD"
                          }, {
                            suffixIcon: _withCtx(() => [
                              _hoisted_35
                            ]),
                            _: 1
                          }, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_collapse_panel, {
                key: "4",
                header: "审核结果类别"
              }, {
                extra: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                    class: "show-collapsed"
                  }, _hoisted_38, 512), [
                    [_vShow, !_ctx.showCollapsed]
                  ])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_space, {
                    direction: "vertical",
                    style: {"margin-bottom":"20px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createVNode(_component_a_select, {
                        allowClear: "",
                        placeholder: "请选择",
                        value: _ctx.approlStatus,
                        "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.approlStatus) = $event))
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.approvalStatusArray, (item) => {
                            return (_openBlock(), _createBlock(_component_a_select_option, {
                              value: item.code,
                              key: item.code
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.msg), 1)
                              ]),
                              _: 2
                            }, 1032, ["value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("div", {
                    onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args))),
                    class: "show-collapsed",
                    style: {"float":"right","margin-top":"40px","cursor":"pointer"}
                  }, _hoisted_42, 512), [
                    [_vShow, _ctx.showCollapsed]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey", "onChange"])
        ], 2)
      ], 2),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_a_table, {
          columns: _ctx.columns,
          scroll: { x: _ctx.tableWidth, y: _ctx.tableHeight },
          pagination: false,
          dataSource: _ctx.tableData,
          rowKey: "id",
          rowClassName: 
          (record, index) => (index % 2 === 1 ? 'table-striped' : null)
        
        }, {
          fail: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              disabled: record.failFlag === '0',
              onClick: ($event: any) => (_ctx.viewReasonEvent(record.vinNo, record.dealerCode))
            }, {
              default: _withCtx(() => [
                _hoisted_44
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ]),
          approlStatus: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(_ctx.EnumControllingApprovalStatus[record.approlStatus]), 1)
          ]),
          checkStatus: _withCtx(({ record }) => [
            _createTextVNode(_toDisplayString(record.checkStatus === ""
              ? "无"
              : _ctx.EnumControllingCheckStatus[record.checkStatus]), 1)
          ]),
          file: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.invoiceEvent(record.vinNo, record.dealerCode)),
              disabled: record.invoicePath === ''
            }, {
              default: _withCtx(() => [
                _hoisted_45
              ]),
              _: 2
            }, 1032, ["onClick", "disabled"]),
            _createVNode(_component_a_divider, { type: "vertical" }),
            (record.usage !== '最终用户用车')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  type: "link",
                  onClick: ($event: any) => (_ctx.licenseEvent(record.vinNo, record.dealerCode)),
                  disabled: record.licensePath === ''
                }, {
                  default: _withCtx(() => [
                    _hoisted_46
                  ]),
                  _: 2
                }, 1032, ["onClick", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({ record }) => [
            _createVNode(_component_a_button, {
              type: "link",
              onClick: ($event: any) => (_ctx.detailEvent(record))
            }, {
              default: _withCtx(() => [
                _hoisted_47
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }, 8, ["columns", "scroll", "dataSource", "rowClassName"])
      ])
    ]),
    _createElementVNode("section", _hoisted_48, [
      _createVNode(_component_a_pagination, {
        total: _ctx.total,
        "show-size-changer": "",
        "show-total": (total) => `共 ${total} 条`,
        onChange: _ctx.pageChange,
        onShowSizeChange: _ctx.sizeChange,
        pageSize: _ctx.size,
        "onUpdate:pageSize": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.size) = $event)),
        current: _ctx.current,
        "onUpdate:current": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.current) = $event)),
        pageSizeOptions: ['10', '20', '30', '40', '50']
      }, {
        buildOptionText: _withCtx((props) => [
          _createElementVNode("span", null, _toDisplayString(props.value) + "条/页", 1)
        ]),
        _: 1
      }, 8, ["total", "show-total", "onChange", "onShowSizeChange", "pageSize", "current"])
    ]),
    (_ctx.pictureModalFlag)
      ? (_openBlock(), _createBlock(_component_Preview, {
          key: 0,
          pictureModal: _ctx.pictureModal,
          footer: null,
          onClosePictureModal: _ctx.closePictureModal
        }, null, 8, ["pictureModal", "onClosePictureModal"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.batchQueryModal,
      "onUpdate:visible": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.batchQueryModal) = $event)),
      width: 420,
      onCancel: _ctx.closeBatchQueryModal,
      class: "batch-query-modal",
      centered: ""
    }, {
      title: _withCtx(() => [
        _createElementVNode("strong", _hoisted_49, _toDisplayString(_ctx.batchQueryTitle), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_button, {
          size: "small",
          onClick: _ctx.clearBatchQuery
        }, {
          default: _withCtx(() => [
            _hoisted_53
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          size: "small",
          type: "primary",
          onClick: _cache[34] || (_cache[34] = ($event: any) => {
          _ctx.batchQueryModal = false;
          _ctx.closeBatchQueryModal();
        })
        }, {
          default: _withCtx(() => [
            _hoisted_54
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_50, [
          _createElementVNode("article", null, [
            _createElementVNode("section", _hoisted_51, _toDisplayString(_ctx.batchQueryListTitle), 1),
            _createElementVNode("section", _hoisted_52, [
              (_ctx.textNoArray.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.textNoArray, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "list-item",
                      key: index
                    }, _toDisplayString(item), 1))
                  }), 128))
                : _createCommentVNode("", true),
              _createVNode(_component_a_input, {
                ref: "input",
                value: _ctx.textContentNo,
                "onUpdate:value": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.textContentNo) = $event)),
                onChange: _ctx.textChangEvent,
                style: {"height":"24px"}
              }, null, 8, ["value", "onChange"]),
              (_ctx.batchPlaceholder.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.batchPlaceholder, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "list-item",
                      style: {"height":"24px","margin-top":"8px"}
                    }))
                  }), 128))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible", "onCancel"]),
    (_ctx.showFailFlag)
      ? (_openBlock(), _createBlock(_component_fail_reason, {
          key: 1,
          showFailFlag: _ctx.showFailFlag,
          failData: _ctx.failData,
          onCloseFailReason: _ctx.closeFailReason
        }, null, 8, ["showFailFlag", "failData", "onCloseFailReason"]))
      : _createCommentVNode("", true),
    (_ctx.isDetailVisible)
      ? (_openBlock(), _createBlock(_component_retail_validation_detail, {
          key: 2,
          isDetailVisible: _ctx.isDetailVisible,
          onCloseDetailVisible: _ctx.closeDetail,
          entity: _ctx.entityData
        }, null, 8, ["isDetailVisible", "onCloseDetailVisible", "entity"]))
      : _createCommentVNode("", true)
  ], 64))
}